import { render } from "./CardImg.vue?vue&type=template&id=f1d1ff88&scoped=true"
import script from "./CardImg.vue?vue&type=script&lang=js"
export * from "./CardImg.vue?vue&type=script&lang=js"

import "./CardImg.vue?vue&type=style&index=0&id=f1d1ff88&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1d1ff88"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QTooltip,QBtn});
